
import { Link } from "react-router-dom";
import { Img } from "../components";

export default function Logo() {
    return (
        <Link to="/" className="flex justify-center items-center w-[22%] sm:w-full">
            <Img src="/images/img_logo_aihumanity.png" alt="AIHumanity" className="h-[28px]" />
        </Link>
    );
}